import styled from 'styled-components'

export const FilesTabWrapper = styled.div`
  padding: ${({ theme }) => theme.spacings[6]};

  & > button {
    margin: 0 auto;
  }
`
